import { Location } from "gen/company/models_pb"
import { Customer } from "gen/customer/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import {
  Sale_Source as SaleSource,
  Sale_Status as SaleStatus,
} from "gen/txn/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

import { cleanStatus } from "./cleanStatus"

const statusSegments: Record<SaleStatus, string> = {
  [SaleStatus.UNDEFINED]: "new",
  [SaleStatus.CREATED]: "drafts",
  [SaleStatus.QUOTED]: "quotes",
  [SaleStatus.WILL_CALLED]: "will-call",
  [SaleStatus.SOLD]: "sold",
  [SaleStatus.PAID]: "sold",
  [SaleStatus.VOIDED]: "voided",
  [SaleStatus.SPECIAL_ORDER]: "special-orders",
}

export function statusSegment(
  saleStatus?: SaleStatus,
  source?: SaleSource
): string {
  if (saleStatus === SaleStatus.WILL_CALLED && source === SaleSource.ECOMM) {
    return "online-orders"
  }
  return statusSegments[saleStatus ?? SaleStatus.UNDEFINED]
}

export function sales({
  status = SaleStatus.UNDEFINED,
  source,
  location,
  customer,
}: {
  status?: SaleStatus
  source?: SaleSource
  location?: Pick<Location, "id" | "name">
  customer?: Pick<Customer, "id" | "name">
} = {}): WebUrl {
  const pathname = `/pos/sales/${statusSegment(status, source)}`

  if (!location && !customer) {
    return {
      pathname,
    }
  }

  const query: QueryParams = {}

  if (location !== undefined) {
    query.locations = encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    )
  }

  if (customer !== undefined) {
    query.customers = encodeQueryParam(
      {
        key: UUID.idString(customer.id),
        value: customer.name,
      },
      true
    )
  }

  return {
    pathname,
    query,
  }
}

export function sale(
  id?: PBUUID,
  status?: SaleStatus,
  source?: SaleSource
): WebUrl {
  const pathname = `/pos/sales/${UUID.idString(id)}`

  const statusParam = saleStatusParam(status)
  if (!statusParam) {
    return {
      pathname,
    }
  }

  const query: QueryParams = { status: statusParam }
  if (source === SaleSource.ECOMM) {
    query.source = "ecomm"
  }

  return {
    pathname,
    query,
  }
}

export function saleStatusParam(status?: SaleStatus): string {
  if (!status) {
    return ""
  }
  if (status === SaleStatus.PAID) {
    return cleanStatus(SaleStatus[SaleStatus.SOLD])
  }
  return cleanStatus(SaleStatus[status])
}
